import { render, staticRenderFns } from "./POPayment.vue?vue&type=template&id=b50bd294"
import script from "./POPayment.vue?vue&type=script&lang=js"
export * from "./POPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports